import type { z as Z } from 'zod';

import { z } from 'zod';

import { CHARACTER_ROLES, KEBAB, narratorFields, nodeFields } from './storyData.js';

/**
 * A character. `imageUrl` is resolved server-side from `contentAssetSlug`, so an authored
 * story may leave it out; the slug itself is required by `contentAssetSlugPresent`.
 */
export const Character = z.looseObject({
  id: z.string().regex(KEBAB),
  name: z.string().min(1),
  role: z.enum(CHARACTER_ROLES),
  title: z.string().min(1),
  imageUrl: z.string().optional(),
  contentAssetSlug: z.string().optional(),
});

export const Node = z.looseObject({
  ...nodeFields,
  branchId: z.string().optional(),
});

/** The inner `storyData` of a story. Envelope-level fields live on `fields.*`. */
export const Story = z.looseObject({
  id: z.string().regex(KEBAB),
  title: z.string().min(1),
  startNodeId: z.string(),
  defaultBackgroundImageUrl: z.string().optional(),
  ...narratorFields,
  longestPathLength: z.number().optional(),
  // Empty for a narrator-only quiz; uniqueness is enforced by charactersUnique.
  characters: z.array(Character),
  nodes: z.array(Node).min(1),
});

export type Story = Z.infer<typeof Story>;
